import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { ProjectLayoutComponent } from './layout/project-layout/project-layout.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { userGuard } from './shared/guards/user.guard';
import { projectGuard } from './shared/guards/project.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login-page/login-page.component').then(c => c.LoginPageComponent)
  },
  {
    path: 'callback',
    loadComponent: () => import('./pages/callback-page/callback-page.component').then(c => c.CallbackPageComponent)
  },
  {
    path: 'logout',
    loadComponent: () => import('./pages/logout-page/logout-page.component').then(c => c.LogoutPageComponent)
  },
  {
    path: 'oauth/complete',
    loadComponent: () => import('./pages/oauth-complete-page/oauth-complete-page.component').then(c => c.OauthCompletePageComponent)
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard, userGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/dashboard-page/dashboard-page.component')
            .then(c => c.DashboardPageComponent),
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('./pages/projects-page/projects-page.component')
            .then(c => c.ProjectsPageComponent),
      },
      {
        path: 'invites',
        loadComponent: () =>
          import('./pages/invites-page/invites-page.component')
            .then(c => c.InvitesPageComponent),
      },
      {
        path: 'help',
        loadComponent: () =>
          import('./pages/help/help.component')
            .then(c => c.HelpPageComponent),
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import('./pages/notifications-page/notifications-page.component')
            .then(c => c.NotificationsPageComponent),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./components/profile-details/profile-details.component')
            .then(c => c.ProfileDetailsComponent),
      }
    ]
  },
  {
    path: 'project/:projectId',
    component: ProjectLayoutComponent,
    canActivate: [AuthGuard, userGuard, projectGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/project-page/project-page.component')
            .then(c => c.ProjectPageComponent)
      },
      {
        path: 'workflow/:workflowId',
        loadComponent: () =>
          import('./pages/project-page/project-page.component')
            .then(c => c.ProjectPageComponent)
      },
      {
        path: 'workflow/:workflowId/step/:stepId',
        loadComponent: () =>
          import('./pages/project-page/project-page.component')
            .then(c => c.ProjectPageComponent)
      },
      {
        path: 'routine/:planId/job-diff/:leftJobId/:rightJobId',
        loadComponent: () =>
          import('./pages/job-diff-page/job-diff-page.component')
            .then(c => c.JobDiffPageComponent)
      },
      {
        path: 'routine/:planId/job/:jobId',
        loadComponent: () =>
          import('./pages/job-detail-page/job-detail-page.component')
            .then(c => c.JobDetailPageComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'login',
  }
];
